export default __webpack_public_path__ + "static/media/EmptyFavoris.1f0d9319.svg";